import * as clientFormConstants from "../constants/clientContactConstants";

const initialState = {
  isLoading: false,
  isSuccess: false,
  isError: false
}

export const addClientFormReducer = (state = initialState, action) => {
  switch (action.type) {
    case clientFormConstants.CLIENT_FORM_REQUEST:
      return { isLoading: true };
    case clientFormConstants.CLIENT_FORM_SUCCESS:
      return { isLoading: false, isSuccess: true };
    case clientFormConstants.CLIENT_FORM_FAIL:
      return { isLoading: false, isError: action.payload };
    default:
      return state;
  }
};